<template>
  <svg class="order-two" width="109.33" height="126.54" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 109.33 126.54"><path fill="#ff6e6e" d="M0 57.88h109.33v68.67H0z"/><path fill="#fc9d9d" d="M56.5 57.88h52.83v68.67H56.5z"/><path fill="#ff8080" d="M56.5 57.88l19.83 43.66h17l16-43.66v68.66H56.5V57.88z"/><path fill="#ebebe6" d="M31 103.48h18.67v15.64H31z"/><path fill="none" stroke="#892e2e" stroke-miterlimit="10" stroke-width=".957" d="M34.07 106.6v9.16m4.79-9.16v9.16m6.42-9.16v9.16"/><path fill="none" stroke="#892e2e" stroke-miterlimit="10" stroke-width=".383" d="M35.74 106.6v9.16m.96-9.16v9.16m3.71-9.16v9.16m.96-9.16v9.16m.96-9.16v9.16m1.47-9.16v9.16"/><path fill="#f76969" d="M6 1.81h90.33v56.73H6z"/><path fill="#ff8080" d="M52.68 1.81h43.65v56.73H52.68z"/><path fill="#ebebe6" d="M30.92 38.92h16.11v13.49H30.92z"/><path fill="none" stroke="#892e2e" stroke-miterlimit="10" stroke-width=".826" d="M33.57 41.61v7.9m4.13-7.9v7.9m5.55-7.9v7.9"/><path fill="none" stroke="#892e2e" stroke-miterlimit="10" stroke-width=".33" d="M35.02 41.61v7.9m.83-7.9v7.9m3.2-7.9v7.9m.82-7.9v7.9m.83-7.9v7.9m1.27-7.9v7.9"/><path fill="#db5656" d="M52.68 1.81L75.45.25l20.88 1.56H52.68z"/><path fill="#ff8080" d="M6 1.81L34.58 0l40.87.25-22.77 1.88L6 1.81z"/></svg>
</template>

<script>
export default {
  name: 'OrderTwo'
}
</script>

<style lang="scss" scoped>
.order-two {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 2;
  animation: 0.55s bounce both;
  transform-origin: center bottom;
}
</style>
